import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconKeyOutlined: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 12C2.25 6.61406 6.61406 2.25 12 2.25C17.3859 2.25 21.75 6.61406 21.75 12C21.75 17.3859 17.3859 21.75 12 21.75C6.61406 21.75 2.25 17.3859 2.25 12ZM17.9672 6.03281C16.3734 4.43906 14.2547 3.5625 12 3.5625C9.74531 3.5625 7.62656 4.43906 6.03281 6.03281C4.43906 7.62656 3.5625 9.74531 3.5625 12C3.5625 14.2547 4.43906 16.3734 6.03281 17.9672C7.62656 19.5609 9.74531 20.4375 12 20.4375C14.2547 20.4375 16.3734 19.5609 17.9672 17.9672C19.5609 16.3734 20.4375 14.2547 20.4375 12C20.4375 9.74531 19.5609 7.62656 17.9672 6.03281Z"
          fill="#200E32"
        />
        <path
          d="M14.6313 14.0447V11.8223"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4453 11.8223H18.0269V14.0447"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4436 11.822C10.4436 13.0484 9.4488 14.0444 8.2212 14.0444C6.9948 14.0444 6 13.0484 6 11.822C6 10.5956 6.9948 9.59961 8.2212 9.59961C9.4488 9.59961 10.4436 10.5956 10.4436 11.822Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};

export default IconKeyOutlined;
